import { render, staticRenderFns } from "./keysMsg.vue?vue&type=template&id=21c282e8"
import script from "./keysMsg.vue?vue&type=script&lang=js"
export * from "./keysMsg.vue?vue&type=script&lang=js"
import style0 from "./keysMsg.vue?vue&type=style&index=0&id=21c282e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports